import React from 'react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-olive-dark text-white shadow-md" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="flex justify-between items-center h-20" data-id="element-86">
          <div className="flex items-center gap-3" data-id="element-87">
            <span className="text-2xl" data-id="element-88">📋</span>
            <span className="font-serif md:text-2xl font-bold tracking-wide text-[16px]" data-id="element-89">
              Sistema PRO: Terapeuta Ocupacional
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8" data-id="element-90">
            <a href="#bonos" className="text-sm font-medium hover:text-golden transition-colors" data-id="element-91">
              Bonos
            </a>
            <a href="#testimonios" className="text-sm font-medium hover:text-golden transition-colors" data-id="element-92">
              Testimonios
            </a>
            <a href="#comprar" className="bg-golden hover:bg-golden-hover text-white px-6 py-2.5 rounded-full text-sm font-bold uppercase tracking-wider transition-colors shadow-lg" data-id="element-93">
              Comprar Ahora
            </a>
          </div>
        </div>
      </div>
    </nav>;
}